<template>
    <div @scroll="onScroll" style="height:100vh; overflow-y: scroll;">
        <b-overlay :show="isSaving">
            <!-- FIND YOUR SCHOOL BOX -->
            <section>
                <div class="d-none">
                    CustomerID: {{customerId}}<br/>
                    CompanyID: {{companyId}}
                </div>
                <b-container>
                    <b-alert variant="warning" show>Please provide updated contacts for your ongoing adoption/contract order. If multiple roles are fulfilled by one person, please provide a minimum of 2 contacts. </b-alert>
                    <!-- SCHOOL SEARCH -->
                    <b-card no-body v-if="!contactData.school">
                        <template #header>
                            <h4>Find your District / School</h4>
                        </template>
                        <p class="m-2">Please select your district and school (if applicable).</p>
                        <b-tabs card content-class="mt-3" v-model="formSettings.selectedTab">
                            <!-- ZIPCODE SEARCH -->
                            <b-tab title="Zipcode">
                                <b-input-group prepend="Zipcode:">
                                    <b-input type="text" placeholder="" v-model="searchZip" @input="zipDebounce()"></b-input>
                                </b-input-group>
                            </b-tab>
                            <b-tab title="Select">

                                <!-- MANUAL SELECTION -->
                                <b-form-group>
                                    <label for="state">State:</label>
                                    <b-select id="state" v-model="contactData.state" @input="getSchoolDistrictsForState()">
                                        <b-select-option v-for="(state, i) in states" :value="state.state" :key="state.state">{{state.fullState}}</b-select-option>
                                    </b-select>
                                </b-form-group>
                                <b-overlay :show="districts.length === 0">
                                    <template #overlay>...</template>
                                    <b-form-group>
                                        <label for="district">District / Organization:</label>
                                        <b-select id="district" v-model="contactData.district" @input="getSchoolsForDistrict()">
                                            <b-select-option v-for="(district, i) in districts" :value="district" :key="`district${i}`">
                                                {{district.name}}
                                            </b-select-option>
                                        </b-select>
                                    </b-form-group>
                                </b-overlay>
                                <b-overlay :show="schools.length === 0">
                                    <template #overlay>...</template>
                                    <b-form-group>
                                        <label for="school">School:</label>
                                        <b-select id="school" v-model="contactData.school">
                                            <b-select-option v-for="(school, i) in schools" :value="school" :key="`school${i}`">
                                                {{school.name}}, {{school.city}}
                                            </b-select-option>
                                        </b-select>
                                    </b-form-group>
                                </b-overlay>
                            </b-tab>
                        </b-tabs>

                        <!-- SEARCH RESULTS -->
                        <div id="searchResults" v-if="schoolsFilteredByState.length">
                            <b-table
                                id="my-table"
                                :items="schoolsFilteredByState"
                                :fields="tableSettings.fields"
                                :per-page="tableSettings.perPage"
                                :current-page="tableSettings.currentPage"
                                small
                            >
                                <template #cell(select)="data">
                                    <b-btn variant="primary" @click="selectSchool(data.item)">Select</b-btn>
                                </template>
                            </b-table>

                            <b-pagination
                                v-show="schoolsFilteredByState.length > tableSettings.perPage"
                                v-model="tableSettings.currentPage"
                                :total-rows="schoolsFilteredByState.length"
                                :per-page="tableSettings.perPage"
                                aria-controls="my-table"
                            ></b-pagination>
                        </div>
                    </b-card>

                    <!-- SCHOOL INFO -->
                    <b-card no-body v-else>
                        <template #header>
                            <div class="row">
                                <h4 class="col">Your District / School</h4>
                                <div class="float-right"><b-btn variant="danger" @click="resetSchool">Reset</b-btn> </div>
                            </div>
                        </template>
                        <div class="m-2">
                            <h4 class="mb-2">{{contactData.school.name}}</h4>
                            {{contactData.school.address}}
                            {{contactData.school.city}}
                            <span v-if="contactData.school.city && contactData.school.address">,</span>
                            {{contactData.school.state}}
                            <span v-if="contactData.school.zip">({{contactData.school.zip}})</span>
                        </div>
                    </b-card>
                </b-container>
            </section>

            <!-- CONTACT FORMS -->
            <section class=" mt-2 mb-5">
                <form @submit.prevent="onFormSubmit">
                    <b-container>
                        <b-row>
                            <b-col><h2>Contact Information</h2></b-col>
                            <b-col v-if="updatedAt"><small class="pt-4 float-right">Last Updated: {{updatedAt}}</small></b-col>
                        </b-row>

                    <template v-for="(contact, i) in contacts">
                        <b-card bg-variant="light" class="my-2">
    <!--                        <h1>{{contact.position}}</h1>-->
                            <b-form-group
                                label-cols-lg="3"
                                :label="contact.position"
                                label-size="lg"
                                label-class="font-weight-bold pt-0"
                                class="mb-0"
                            >
                                <b-form-group
                                    label="First Name:"
                                    label-cols-sm="3"
                                    label-align-sm="right"
                                >
                                    <b-form-input v-model="contact.first_name"></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Last Name:"
                                    label-cols-sm="3"
                                    label-align-sm="right"
                                >
                                    <b-form-input v-model="contact.last_name"></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Email:"
                                    label-cols-sm="3"
                                    label-align-sm="right"
                                >
                                    <b-form-input v-model="contact.email"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Phone:"
                                    label-cols-sm="3"
                                    label-align-sm="right"
                                >
                                    <b-form-input v-model="contact.phone"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    label="Job Title:"
                                    label-cols-sm="3"
                                    label-align-sm="right"
                                >
                                    <b-form-input v-model="contact.title"></b-form-input>
                                </b-form-group>
                            </b-form-group>
                        </b-card>

                    </template>
                    </b-container>
                </form>
            </section>

            <!-- Submit Button -->
            <div id="submit_container" class="" style="right: 136px; color-scheme: light; width: 136px; height: 50px; padding: 0px; margin: 10px 20px; position: fixed; bottom: 0px; overflow: visible; opacity: 1; border: 0px; z-index: 999998; transition-duration: 250ms; transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1); transition-property: opacity, top, bottom;">
                <b-btn id="submit_btn" variant="primary" :disabled="saveDisabled" class="w-100 h-100" style="border-radius: 999rem" @click="onFormSubmit">Submit</b-btn>
            </div>
            <b-popover target="submit_container" triggers="hover" placement="top" :disabled="!saveDisabled">
                Please select your school or organization and fill out the information of at least 2 contacts.
            </b-popover>

        </b-overlay>
    </div>
</template>

<script>

import states from "@/common/states";
import AdoptionNavbar from "@/components/adoptions/AdoptionNavbar";
import AdoptionBreadcrumb from "@/components/adoptions/AdoptionBreadcrumb";

export default {
    name: "ContactForm",
    components: {AdoptionBreadcrumb, AdoptionNavbar},
    props: {
        'customerId': {
            required: true,
        },
        'companyId': {
            required: false,
        }
    },
    computed: {
        schoolsFilteredByState() {
            if (!this.searchState)
                return this.companies;

            return this.companies.filter((school) => {
                return school.state === this.searchState;
            })
        },
    },
    data: () => ({
        // Form Fields
        tableSettings: {
            perPage: 8,
            currentPage: 1,
            fields: ['name', 'city', 'state', 'zip', 'select']
        },
        formSettings: {
            selectedTab: 0,
        },
        saveDisabled: true,
        isSaving: false,
        hideScrollSubmit: false,
        searchString: "",
        searchState: "",
        searchDebounce: null,
        searchZip: "",
        zipDebounce: null,
        companies: [],
        districts: [],
        schools: [],
        states: states,
        updatedAt: null,


        // Form Data
        contactData: {
            state: null,
            district: null,
            school: null,
        },
        contacts: [
            {position: 'Purchasing', description: ''},
            {position: 'Accounts Payable'},
            {position: 'Shipping/Receiving'},
            {position: 'Curriculum'},
            {position: 'Rostering/Technical'},
            {position: 'Optional/Other Contact'},
        ]
    }),
    watch: {
        'contactData.school'() {
            this.setSaveDisabled();
        }
    },
    methods: {
        setSaveDisabled() {
            this.saveDisabled = (this.isSaving || !this.contactData.state || !this.contactData.district || !this.meetsMinimumRequirements());
            // console.log("save?", !this.saveDisabled);
        },
        meetsMinimumRequirements() {
            var numberOfValidContacts = 0;

            for (let i = 0; i < this.contacts.length; ++i) {
                if (this.contacts[i].first_name && (this.contacts[i].email || this.contacts[i].phone))
                    numberOfValidContacts++;
            }
            return numberOfValidContacts >= 2; // TODO: magic number
        },
        onFormSubmit() {
            this.isSaving = true;
            this.axios.post('adoption/contact', {
                ...this.contactData,
                customer_id: this.customerId,
                contacts: this.contacts,
            })
            .then(() => {
                this.$bvModal.msgBoxOk('Your information has been recorded. Thank you!', {title: 'Saved Successfully'});
                this.$swal({
                    toast: true,
                    html: 'saved',
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2500
                })
            }).catch(() => {
                this.$swal({
                    toast: true,
                    html: 'something went wrong',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3500
                })
            }).finally(() => {
                this.isSaving = false;
            })
        },
        async searchSchools() {
            let searchResult = await this.$store.dispatch('searchSchools', this.searchString);

            if (!searchResult || !searchResult.data)
                return;

            this.companies = searchResult.data;
        },
        async getSchoolDistrictsForState() {
            let response = await this.$store.dispatch('listDistrictsByState', this.contactData.state)

            if (!response)
                return;

            // Sort by name alphabetically
            response.data.sort((a, b) => {
                let aName = a.name.trim();
                let bName = b.name.trim();
                return (aName > bName) ? 1 : (aName < bName) ? -1 : 0
            })

            this.districts = response.data;
        },
        async getSchoolsForDistrict() {
            let response = await this.$store.dispatch('listSchoolsByDistrit', this.contactData.district.id);

            if (!response)
                return;

            // if (!response.data.length) {
                this.schools = [this.contactData.district];
                // return;
            // }

            // Sort by name alphabetically
            response.data.sort((a, b) => {
                let aName = a.name.trim();
                let bName = b.name.trim();
                return (aName > bName) ? 1 : (aName < bName) ? -1 : 0
            })
            this.schools = [this.contactData.district, ...response.data];
        },
        async searchByZip() {
            let response = await this.$store.dispatch('listByZipcode', this.searchZip);
            if (!response)
                return;

            this.companies = response.data;
            this.companies.sort((a,b) => (a.name > b.name ? 1 :(a.name < b.name) ? -1 : 0));
        },
        selectSchool(school) {
            console.log(school);

            this.contactData.state = school.state;
            this.contactData.school = school;

            if (school.parents) {
                this.contactData.district = school.parents[0];
                this.contactData.district.id = school.parents[0].id;
            } else {
                this.contactData.district = school;
            }

            this.resetSearches();
        },
        resetSearches() {
            this.formSettings.selectedTab = 0;
            this.companies = [];
            this.searchState = "";
            this.searchString = "";
            this.searchZip = "";
        },
        resetSchool() {
            this.contactData.state = null;
            this.contactData.district = null;
            this.contactData.school = null;
        },
        onScroll({ target: { scrollTop, clientHeight, scrollHeight }}) {

        },
        preloadContacts() {
            this.isSaving = true;
            this.axios.get(`adoption/contact/`, {params: {customer_id: this.customerId, company_id: this.companyId}})
                .then((response) => {

                    if (!response || !response.data)
                        return;

                    let responseData = JSON.parse(response.data[0].contact_data);
                    console.log(responseData);
                    this.contactData.district = responseData.district;
                    this.contactData.school = responseData.school;
                    this.contactData.state = responseData.state;
                    this.updatedAt =  new Date(response.data[0].updated_at).toLocaleDateString();
                    for (let i = 0; i < this.contacts.length; ++i) {
                        this.contacts[i] = responseData.contacts.find((a) => a.position == this.contacts[i].position);
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                });
        }
    },
    mounted: function(){
        this.contacts.forEach(contact => {
            this.$watch(() => this.setSaveDisabled());
        });
    },
    created() {
        if (this.customerId || this.companyId)
            this.preloadContacts();

        this.searchDebounce =  _.debounce(this.searchSchools, 450);
        this.zipDebounce = _.debounce(this.searchByZip, 450);


    }
}
</script>

<style scoped>

</style>